// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-svg[data-v-3d5ccc3a]{width:21px;height:21px}[data-v-3d5ccc3a] .multiselect__option--highlight{background-color:#f3f2f2;color:#000}[data-v-3d5ccc3a] .multiselect__tag{background-color:#1b5297}[data-v-3d5ccc3a] .multiselect__input{font-size:14px}", ""]);
// Exports
module.exports = exports;
